.card {
  cursor: pointer;
  margin: 0 0 1rem;
  padding: 1rem 2rem;
  background-color: white;
  margin: var(--section-margin) 0;
}

.titleRow {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.score {
  flex-wrap: wrap;
}

.score > :last-child {
  flex-shrink: 0;
}

.contentRow {
  display: flex;
  flex: 1 1 10rem;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.info {
  flex-grow: 1;
  align-items: center;
}

.meta {
  color: var(--color-text-muted);
  font-size: 1.125rem;
  margin: 0;
  text-align: left;
}
